export default __webpack_public_path__ + "static/wifi_b.5a87bf0c599b290ebe8cfa7795d596da.svg";